import { render, staticRenderFns } from "./cestasPorTipoEscolaForRegional.vue?vue&type=template&id=5d9a8832"
import script from "./cestasPorTipoEscolaForRegional.vue?vue&type=script&lang=js"
export * from "./cestasPorTipoEscolaForRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports